import React, { PureComponent } from 'react';
import { change, action } from '../propTypes';

import { Text } from '@ontruck/orc';

import { EDIT } from 'modules/recurring-orders/ChangesPreviewModal/constants';

import { TableCellStyled } from './styled';

const t = {
  CANCEL: {
    CANCEL: 'Will be cancelled',
    NONE: 'Will not be cancelled',
  },
  EDIT: {
    CREATE: 'Will be created',
    CANCEL: 'Will be cancelled',
    EDIT: 'Will be modified',
    NONE: 'Will not be modified',
  },
  previous_changes_will_be_lost: 'All previous changes will be lost',
};

const colors = {
  CREATE: 'greenKiwi',
  CANCEL: 'redCherry',
  EDIT: 'greyWolf',
  NONE: 'orangePeach',
};

class TableCellChanges extends PureComponent {
  render() {
    const { change, action } = this.props;

    return (
      <TableCellStyled>
        <Text text={t[action][change]} display="block" color={colors[change]} />
        {action === EDIT && change === EDIT && (
          <Text text={t.previous_changes_will_be_lost} display="block" color="orangePeach" />
        )}
      </TableCellStyled>
    );
  }
}

TableCellChanges.propTypes = {
  change,
  action,
};

export default TableCellChanges;
